import { render, staticRenderFns } from "./MultiselectInput.vue?vue&type=template&id=f427eab8&"
import script from "./MultiselectInput.vue?vue&type=script&lang=js&"
export * from "./MultiselectInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports